
const Order = () => {
    return (
        <div>
            <h1>Order</h1>
            <div>
                This is Order component.
            </div>
        </div>
    );
}

export default Order;
